
/*

	SKETCH CODE !	

*/

import { Box, TabPanels, Tabs, TabList, Tab, TabPanel, Text, Grid, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Textarea } from "@chakra-ui/react";
import { ResponsiveBar } from "@nivo/bar";
import PageHeader from "components/text/PageHeader";
import { DashboardNumber } from "pages/ISSB/Dashboard/components/RequirementsCard";
import { ResponsivePie } from "@nivo/pie";
import DashboardCard from "pages/ISSB/Dashboard/components/DashboardCard";
import { H2Dashboard } from "components/text/headings";
import { DonutChart } from "pages/SupplierDashboard/components/SupplierSpecificReport/components";
import SketchContainer from "pages/SketchContainer";
import { useEffect, useState } from "react";
import { setAIContext } from "api/ai/ai.service";
import { useDisclosure } from "@chakra-ui/react";
import { Trash } from "@phosphor-icons/react";
import DataTableV2 from "components/DataTable/DateTableV2";
import { mockCSVData } from "pages/AgenticDashboard/mockCSVData";	

const mockBarData = [
  { month: "Jan", carbon: 120 },
  { month: "Feb", carbon: 145 },
  { month: "Mar", carbon: 130 },
  { month: "Apr", carbon: 155 },
  { month: "May", carbon: 140 },
  { month: "Jun", carbon: 165 },
  { month: "Jul", carbon: 150 },
  { month: "Aug", carbon: 175 },
  { month: "Sep", carbon: 160 },
  { month: "Oct", carbon: 185 },
  { month: "Nov", carbon: 170 },
  { month: "Dec", carbon: 195 }
];

const mockPieData = [
  {
    "id": "Scope 1 - Direct Emissions",
    "label": "Scope 1 - Direct Emissions",
    "value": 25,
    "color": "#FF6B6B"
  },
  {
    "id": "Scope 2 - Electricity",
    "label": "Scope 2 - Electricity",
    "value": 35,
    "color": "#4ECDC4"
  },
  {
    "id": "Scope 3 - Supply Chain",
    "label": "Scope 3 - Supply Chain",
    "value": 40,
    "color": "#45B7D1"
  }
]

export default function AgenticDashboard() {
  // TODO replace the AI Assist with a specialised one
  setAIContext({
    app_page_name: "agenticDashboard",
	agent: "data_analyst"
  });

  const [selectedTab, setSelectedTab] = useState(0);	
  // get the selected tab from the URL dtab parameter
  useEffect(() => {
    const dtab = new URLSearchParams(window.location.search).get('dtab');
    if (dtab) {
      setSelectedTab(parseInt(dtab));
    }
  }, []);
  // alter url when tab changes
  useEffect(() => {
    window.history.replaceState({}, '', window.location.pathname + '?dtab=' + selectedTab);
  }, [selectedTab]);
	
  return (<SketchContainer>
      <PageHeader title="Agentic Dashboard" />	  
	  <Tabs index={selectedTab} onChange={setSelectedTab}>
		<TabList>
			<Tab>Overview (we manage this)</Tab>
			<Tab>Custom Dashboard #1 (user can save their own analytics)</Tab>
		</TabList>
		<TabPanels>
			<TabPanel>
				<H2Dashboard>Our design of the best overall data analytics and visualisation</H2Dashboard>
				<Grid templateColumns="40% 60%" gap={4}>
					<DashboardCard>
						<DashboardNumber value={10} unit="tCO2e" title="Total Carbon Footprint" />
					</DashboardCard>
					<DashboardCard>
						<H2Dashboard>Carbon by Scope</H2Dashboard>
						<Box height="400px">
							<ResponsivePie 
								data={mockPieData}
								margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
								innerRadius={0.5}
								padAngle={0.7}
								cornerRadius={3}
								activeOuterRadiusOffset={8}
								colors={{ datum: 'data.color' }}
								borderWidth={1}
								borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
								arcLinkLabelsSkipAngle={10}
								arcLinkLabelsTextColor="#333333"
								arcLinkLabelsThickness={2}
								arcLinkLabelsColor={{ from: 'color' }}
								arcLabelsSkipAngle={10}
								arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
								enableArcLabels={true}
								enableArcLinkLabels={true}
								legends={[
									{
										anchor: 'bottom',
										direction: 'row',
										justify: false,
										translateY: 56,
										itemsSpacing: 0,
										itemWidth: 100,
										itemHeight: 18,
										itemTextColor: '#999',
										itemDirection: 'left-to-right',
										itemOpacity: 1,
										symbolSize: 18,
										symbolShape: 'circle'
									}
								]}
							/>
						</Box>
					</DashboardCard>
				</Grid>
				<DashboardCard>
					<H2Dashboard>Carbon by Category</H2Dashboard>
					<Box height="400px">
						<ResponsiveBar
							data={mockBarData}
							keys={['carbon']}
							indexBy="month"
							margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
							padding={0.3}
							valueScale={{ type: 'linear' }}
							indexScale={{ type: 'band', round: true }}
							colors={{ scheme: 'nivo' }}
							borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
							axisTop={null}
							axisRight={null}
							axisBottom={{
								tickSize: 5,
								tickPadding: 5,
								tickRotation: 0,
								legend: 'Month',
								legendPosition: 'middle',
								legendOffset: 32
							}}
							axisLeft={{
								tickSize: 5,
								tickPadding: 5,
								tickRotation: 0,
								legend: 'Carbon (tCO2e)',
								legendPosition: 'middle',
								legendOffset: -40
							}}
							labelSkipWidth={12}
							labelSkipHeight={12}
							labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
							legends={[
								{
									dataFrom: 'keys',
									anchor: 'bottom-right',
									direction: 'column',
									justify: false,
									translateX: 120,
									translateY: 0,
									itemsSpacing: 2,
									itemWidth: 100,
									itemHeight: 20,
									itemDirection: 'left-to-right',
									itemOpacity: 0.85,
									symbolSize: 20,
									effects: [
										{
											on: 'hover',
											style: {
												itemOpacity: 1
											}
										}
									]
								}
							]}
							animate={true}
							motionStiffness={90}
							motionDamping={15}
						/>
					</Box>
				</DashboardCard>
			</TabPanel>
			<TabPanel>
				<Text>User can save charts here</Text>
				<ExampleCard title="Carbon Data" />
			</TabPanel>
		</TabPanels>
	  </Tabs>
	</SketchContainer>
  );
}


const ExampleCard = ({title}) => {
	const { isOpen, onOpen, onClose } = useDisclosure();
    // Date, Supplier, Product, Units, Price, Carbon (kgCO2e), Category
	const columns = [
		{
			header: 'Date',
			accessorKey: 'date',
			size: 125
		},
		{
			header: 'Supplier',
			accessorKey: 'supplier',
			size: 150
		},
		{
			header: 'Product',
			accessorKey: 'product',
			size: 150
		},
		{
			header: 'Units',
			accessorKey: 'units',
			size: 80
		},
		{
			header: 'Price',
			accessorKey: 'price',
			size: 80
		},
		{
			header: 'Carbon',
			accessorKey: 'carbon',
			size: 80
		},
		{
			header: 'Category',
			accessorKey: 'category'
		}
	];

	let csvRows = mockCSVData.split('\n').map(row => row.split(',').map(cell => cell.trim()));
	const headers = csvRows.shift();
	const csvData = csvRows.map(row => headers.reduce((acc, header, index) => {
		acc[header.toLowerCase().replace(/\W+/g, '_')] = row[index];
		return acc;
	}, {}));

	return (
		<DashboardCard>
			<DataTableV2
				data={csvData}
				columns={columns}
				serverSidePagination={false} 
          		showPaginator={false} 
          		maxHeight="400px"
			/>

			<Button onClick={onOpen} variant="outline" size="xs" mt={2} alignSelf="flex-end">
				View Code
			</Button>
			<Button variant="outline" size="xs" mt={2} alignSelf="flex-end"><Trash /></Button>
			<Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
				<ModalOverlay />
				<ModalContent bg="white">
					<ModalHeader>Analytics Code for {title}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Textarea
							readOnly
							size="sm"
							height="200px"
							value={`widget:"Table"
data: all_carbon_data`}
						/>
					</ModalBody>
					<ModalFooter>
						<Button variant="ghost" onClick={onClose}>Close</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</DashboardCard>
	);
};